import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as profileActions from '../../actions';
import * as Buttons from '../../elements/ui/buttons';
import * as UI from '../../elements/ui';
import * as helpers from '../../helpers/generalHelpers';

const ProfileHOCWithList = (AddForm, HOCList) => {
	class _ProfileHOCWithList extends Component {
		constructor(props) {
			super(props);
			this.state = {
				isThisFormOpen: false,
				stayOpen: false,
				formId: null,
				error: false,
				postError: false,
			};
		}

		componentWillMount() {
			const formId = helpers.randomNum();
			this.setState({ formId });
		}

		componentWillReceiveProps(nextProps) {
			if (nextProps.formOpenId === null) this.setState({ error: false });
			this.props.data.personId && this.props.formOpenId !== nextProps.formOpenId
				? this.props.getProfileComplete(this.props.data.personId)
				: null;
		}

		handleEditing = toggle => {
			const { setFormVisibility, isOtherFormOpen } = this.props,
				{ formId } = this.state;

			if (toggle) {
				if (isOtherFormOpen) return this.setState({ error: true });
				else {
					this.setState({ isThisFormOpen: true });
					return setFormVisibility(toggle, formId);
				}
			} else {
				this.setState({ isThisFormOpen: false });
				return setFormVisibility(toggle, null);
			}
		};

		callBackFromApi = error => {
			if (error) return this.setState({ postError: error.status });
			const { setFormVisibility } = this.props,
				{ stayOpen } = this.state;
			this.setState({ isThisFormOpen: false });
			setFormVisibility(false, null);
			return stayOpen ? null : this.handleEditing(false);
		};

		handleAdding = form => {
			const { data, componentAction } = this.props,
				personId = data.personId || data.person_id,
				payload = form ? form : null,
				type = form ? form.type : 'DELETE';
			return componentAction(personId, payload, type, this.callBackFromApi);
		};

		render() {
			const { data, actionName, guestMode } = this.props,
				{ isThisFormOpen, error, postError } = this.state,
				{ styles, body, noData } = data;
			//
			if (noData && guestMode) return null;

			return (
				<section id={styles && styles.id} className={styles && styles.section}>
					<div className="container">
						<div className="row">
							<div className="profile-list col-12">
								<div className="profile-section-header-box">
									<h2 className={`h2 ${styles && styles.header.style} `}>
										{styles && styles.header.content}
									</h2>
									<UI.OpenFormError
										error={error}
										isGuestMode={guestMode ? guestMode : false}
									/>
									<UI.PostErrorMessage
										error={postError}
										onClose={() => this.setState({ postError: false })}
									/>
									{/*show when not in guestMode*/}
									{!guestMode && (
										<div>
											<p className="p-tag section-visibility-info">
												{styles && styles.message}
											</p>
											<Buttons.AddButtonAchievements
												isOpen={isThisFormOpen}
												handleAdding={() => this.handleEditing(!isThisFormOpen)}
											/>
											{isThisFormOpen && (
												<AddForm
													{...this.props}
													handleAdding={form => this.handleAdding(form)}
													onCancel={() => this.handleEditing(false)}
												/>
											)}
										</div>
									)}
									{/*/////////////////////////*/}
									{body && body[0] && (
										<HOCList
											guestMode={guestMode}
											body={body}
											actionName={actionName}
											styles={styles}
										/>
									)}
								</div>
							</div>
						</div>
					</div>
				</section>
			);
		}
	}

	const mapStateToProps = state => {
		return {
			formOpenId: state.profile.forms.Id,
			isOtherFormOpen: state.profile.forms.editing,
			// networkId: state.profile.visibility.networkId
		};
	};

	const mapDispatchToProps = (dispatch, props) => {
		return {
			setFormVisibility: (toggle, formId) =>
				dispatch(profileActions.showForm(toggle, formId)),
			componentAction: (personId, payload, type, callback) =>
				dispatch(
					profileActions[props.actionName](personId, payload, type, callback)
				),
			getProfileComplete: personId =>
				dispatch(profileActions.getProfileComplete(personId)),
		};
	};

	return connect(
		mapStateToProps,
		mapDispatchToProps
	)(_ProfileHOCWithList);
};

export default ProfileHOCWithList;



// WEBPACK FOOTER //
// src/client/components/site/features/profile/components/HOC/ProfileHOCWithLists.js